export default __webpack_public_path__ + "static/media/bluedots.b66ae674.gif";